import { isEqual } from 'lodash';
import { getUsersIds } from 'modules/queues/common/selectors/userIds';
import { startObserveAvailabilityUpdates } from 'modules/websocket/actions/availabilityUpdates';
import { startObserveUserUpdates } from 'modules/websocket/actions/userUpdates';

import createAction from '.';

export const SET_USER_IDS = createAction('SET_USER_IDS');

export const resubscribeUserAndAvailabilityUpdates = (dispatch, getState) => {
  const state = getState();
  const archiveOpened = state.queues.common.appointmentInfo.isArchiveOpened;
  const { userIds } = state.queues.common.updatedAvailability;
  const newUserIds = getUsersIds(state);

  if (!isEqual(userIds.sort(), newUserIds.sort())) {
    dispatch({
      type: SET_USER_IDS,
      payload: { userIds: newUserIds },
    });

    dispatch(startObserveUserUpdates(newUserIds));

    if (!archiveOpened) {
      dispatch(startObserveAvailabilityUpdates(newUserIds));
    }
  }
};
